import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M12.1333 0H1.8667C.84 0 0 .847 0 1.8824v12.2352C0 15.153.84 16 1.8667 16h10.2666C13.16 16 14 15.153 14 14.1176V1.8824C14 .847 13.16 0 12.1333 0zM1.8667.9412h10.2666c.5134 0 .9334.4235.9334.9412v.9411H.9333v-.9411c0-.5177.42-.9412.9334-.9412zm10.2666 14.1176H1.8667c-.5134 0-.9334-.4235-.9334-.9412V3.7647h12.1334v10.353c0 .5176-.42.9411-.9334.9411z',
    'M9.7882 9.4l-4.9411 3.5c-.234.1657-.5658.1209-.7412-.1A.482.482 0 0 1 4 12.5v-7c0-.2761.237-.5.5294-.5.1146 0 .226.035.3177.1l4.9411 3.5c.234.1657.2813.479.1059.7a.5157.5157 0 0 1-.1059.1z',
  ],
  height: 16,
  width: 14,
});
